/**
 * Availability flags for the "Vær og vannstand" sheet (spec 11/12), mirroring
 * the base-chart `sources` pattern. Weather is hidden entirely (no chip, no
 * sheet section) when the server has no `MET_USER_AGENT` configured — fetched
 * once at app start.
 */
import { create } from 'zustand';

interface SourcesState {
  weatherAvailable: boolean;
  tideAvailable: boolean;
  loaded: boolean;
  load: () => Promise<void>;
}

export const useConditionsSourcesStore = create<SourcesState>((set) => ({
  weatherAvailable: false,
  tideAvailable: false,
  loaded: false,

  load: async () => {
    try {
      const res = await fetch('/api/conditions/sources');
      if (!res.ok) return;
      const data = (await res.json()) as { weather: { available: boolean }; tide: { available: boolean } };
      set({ weatherAvailable: data.weather.available, tideAvailable: data.tide.available, loaded: true });
    } catch {
      /* offline / not configured — stay hidden */
    }
  },
}));
